import React, { useState, useEffect } from "react";
import Layout from "../../layout/Layout";
import { Form, InputGroup } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../utils/axiosConfig";
import * as CustomToast from "../../components/CustomToastMessage";
import MyEditor from "../../components/MyEditor";
import ImageUpload from "../../components/ImageUpload";
import MultipleSelectDropdown from "../../components/MultipleSelectDropdown";

function ProductsAdd() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    link: "",
    // category: '',
    categories: [],
  });
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  // Fetch categories on mount
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axiosInstance.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/admin/category/list`,
          {
            params: { page: 1, limit: 1000, search: "" },
          }
        );
        if (response.data.success) {
          setCategories(response.data.data);
        } else {
          setCategories([]);
        }
      } catch (error) {
        setCategories([]);
      }
    };
    fetchCategories();
    return () => {
      images.forEach((image) => {
        if (image.isNew) {
          URL.revokeObjectURL(image.url);
        }
      });
    };
  }, [images]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "price" || name === "discount") {
      const cleanNumber = value.replace(/[^0-9.,]/g, "");
      setFormData((prev) => ({
        ...prev,
        [name]: cleanNumber,
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleImageSelect = (selectedFiles) => {
    const newImages = selectedFiles.map((file) => ({
      url: URL.createObjectURL(file),
      isNew: true,
      file: file,
    }));
    setImages((prev) => [...prev, ...newImages]);
  };

  const handleImageDelete = (index) => {
    const imageToDelete = images[index];
    URL.revokeObjectURL(imageToDelete.url);
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
      
    if (!images?.length) {
      CustomToast.error("Image is required");
      return;
    }
    if (!formData.categories.length) {
      CustomToast.error("Please select at least one category");
      return;
    }
    const formDataToSend = new FormData();
    formDataToSend.append("name", formData.name);
    formDataToSend.append("link", formData.link);
    // formDataToSend.append("category", formData.category);
    images.forEach((image) => {
      formDataToSend.append("productImage", image.file);
    });
    formData?.categories.forEach((categoryData, index) => {
      formDataToSend.append(`categories[${index}]`, categoryData?.value);
    });

    setLoading(true);
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/admin/product/create`,
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      CustomToast.success(response.data.message);
      navigate("/products");
    } catch (error) {
      if (error.response?.data?.status === 400) {
        CustomToast.error(error.response?.data?.message);
      }
      console.error(error.response?.data?.message || "Internal server error");
    } finally {
      setLoading(false);
    }
  };

  const handleEditorChange = (content) => {
    setFormData((prev) => ({
      ...prev,
      content: content,
    }));
  };

  return (
    <Layout title="Add New Product">
      <main>
        <div className="card page-card">
          <div className="card-body">
            <div className="row g-3">
              <div className="col-12">
                <Form.Group controlId="productImage">
                  <Form.Label>Product Image</Form.Label>
                  <ImageUpload
                    onFileSelect={handleImageSelect}
                    onDelete={handleImageDelete}
                    images={images}
                    multiple={false}
                  />
                </Form.Group>
              </div>
              <div className="col-12">
                <Form.Group controlId="name">
                  <Form.Label>Product Name</Form.Label>
                  <Form.Control
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    placeholder="Enter product name"
                  />
                </Form.Group>
              </div>
              <div className="col-12">
                {/* <Form.Group controlId="category">
                  <Form.Label>Category</Form.Label>
                  <Form.Select
                    name="category"
                    value={formData.category}
                    onChange={handleInputChange}
                    required
                    multiple={true}
                  >
                    <option value="">Select category</option>
                    {categories.map((cat) => (
                      <option key={cat._id} value={cat._id}>
                        {cat.name}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group> */}
                <Form.Group controlId="categories">
                  <Form.Label>Category</Form.Label>
                  <MultipleSelectDropdown
                    options={
                      categories?.map((item) => ({
                        value: item._id,
                        label: item.name,
                      })) || []
                    }
                    value={formData.categories}
                    isMulti
                    name="categories"
                    id="categories"
                    className="p-0"
                    placeholder="Select Categories"
                    isSearchable
                    onChange={(selectedItems, e) => {
                      setFormData((prev) => ({
                        ...prev,
                        categories: selectedItems,
                      }));
                    }}
                  />
                </Form.Group>
              </div>
              {/* <div className="col-12 col-lg-6">
                                <Form.Group controlId="price">
                                    <Form.Label>Original Price</Form.Label>
                                    <InputGroup className="custom-input-group">
                                        <InputGroup.Text id="basic-addon1">$</InputGroup.Text>
                                        <Form.Control
                                            type="text"
                                            name="price"
                                            value={formData.price}
                                            onChange={handleInputChange}
                                            placeholder="Enter product price"
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </div> */}
              {/* <div className="col-12 col-lg-6">
                                <Form.Group controlId="discount">
                                    <Form.Label>Discount Price</Form.Label>
                                    <InputGroup className="custom-input-group">
                                        <InputGroup.Text id="basic-addon1">$</InputGroup.Text>
                                        <Form.Control
                                            type="text"
                                            name="discount"
                                            value={formData.discount}
                                            onChange={handleInputChange}
                                            placeholder="Enter product discount price"
                                        />
                                    </InputGroup>
                                </Form.Group>
                            </div> */}
              <div className="col-12">
                <Form.Group controlId="link">
                  <Form.Label>Product Link</Form.Label>
                  <Form.Control
                    type="url"
                    name="link"
                    value={formData.link}
                    onChange={handleInputChange}
                    placeholder="Enter product link"
                  />
                </Form.Group>
              </div>
              {/* <div className="col-12">
                                <Form.Group controlId="Password">
                                    <Form.Label>Content</Form.Label>
                                </Form.Group>
                                <MyEditor
                                    htmlData={formData.content}
                                    setCourseAdd={(content) => {
                                        handleEditorChange(content);
                                    }}
                                />
                            </div> */}
              <div className="col-12 d-flex justify-content-end gap-3">
                <button
                  className="btn-outline fs-16 fw-700 px-4"
                  onClick={() => navigate("/products")}
                >
                  Cancel
                </button>
                <button
                  className="btn-primary fs-16 fw-700 px-4"
                  onClick={handleSubmit}
                  disabled={loading}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Layout>
  );
}

export default ProductsAdd;
